import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ScanEye } from "lucide-react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import i18n from "@/i18n";

const API = `${process.env.REACT_APP_API_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params  = new URLSearchParams(window.location.search);
    const code    = params.get("code");
    const error   = params.get("error");

    if (error) {
      navigate("/login?error=auth_cancelled", { replace: true });
      return;
    }

    if (code) {
      const redirectUri = `${window.location.origin}/auth/callback`;
      const detectedLang = i18n.language?.split("-")[0] || "id";
      axios
        .post(`${API}/auth/google/callback`, { code, redirect_uri: redirectUri, language: detectedLang }, { withCredentials: true })
        .then((res) => {
          setUser(res.data);
          navigate("/dashboard", { replace: true });
        })
        .catch(() => {
          navigate("/login?error=auth_failed", { replace: true });
        });
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 rounded-sm bg-brand-primary/10 border border-brand-primary/30 flex items-center justify-center mx-auto">
          <ScanEye className="w-6 h-6 text-brand-primary animate-pulse" />
        </div>
        <div>
          <p className="font-heading font-semibold text-lg">Memverifikasi identitas...</p>
          <p className="text-sm text-muted-foreground font-mono mt-1">Mohon tunggu sebentar</p>
        </div>
      </div>
    </div>
  );
}
